// Bootstrap modal default z-index (BS 5). Nested modals bump via modal--navigation.
export const BOOTSTRAP_MODAL_Z_INDEX = 1055
export const NESTED_BACKDROP_OFFSET = 10
export const NESTED_MODAL_OFFSET = 20
// Portaled overlays (Tom Select, address suggestions, …) must sit above the topmost modal.
export const PORTALED_OVERLAY_OFFSET = 30

export function topmostOpenModalZIndex (exclude = null) {
  const openModals = [...document.querySelectorAll(".modal.show")]
    .filter((modal) => modal !== exclude)

  if (!openModals.length) return BOOTSTRAP_MODAL_Z_INDEX

  return Math.max(
    BOOTSTRAP_MODAL_Z_INDEX,
    ...openModals.map((modal) => (
      Number.parseInt(window.getComputedStyle(modal).zIndex, 10) || BOOTSTRAP_MODAL_Z_INDEX
    ))
  )
}

export function zIndexAboveOpenModals ({ exclude = null, offset = PORTALED_OVERLAY_OFFSET } = {}) {
  return String(topmostOpenModalZIndex(exclude) + offset)
}

export function applyZIndexAboveOpenModals (element, options = {}) {
  if (!element) return

  // Override stylesheet !important floors (e.g. body > .ts-dropdown { z-index: 1060 !important }).
  element.style.setProperty("z-index", zIndexAboveOpenModals(options), "important")
}
